import StatusIcon from "components/Atoms/StatusIcon"
import { Status } from "generated/graphql"
import React from "react"

type BeatStatusIconType = {
  status?: string
}
const BeatStatusIcon = ({ status }: BeatStatusIconType) => {
  return (
    <StatusIcon
      condition={status}
      values={{
        [Status.ON_GOING]: { intent: "primary", text: "On Going" },
        [Status.NOT_STARTED]: { intent: "warning", text: "Not Started" },
        [Status.COMPLETED]: { intent: "success", text: "Completed" },
        [Status.PAUSE]: { intent: "danger", text: "Paused" },
      }}
    />
  )
}

export default BeatStatusIcon
